import Vue from "vue";
import Cursus from '../../../packages/cursus/src';

Vue.use(Cursus);
Vue.component('cursus', () => ({
    component: import(/* webpackChunkName: 'cursus' */'../../../packages/cursus/src/component'),
    loading: {
        template: '<div><slot /></div>',
    },
    delay: 0,
}));
Vue.component('cursus-account-form', () => ({
    component: import(/* webpackChunkName: 'cursus-account-form' */'../../../packages/cursus/src/components/AccountForm'),
    loading: {
        template: '<div><slot /></div>',
    },
    delay: 0,
}))
